import React, { Component } from 'react';
//import SideBar from '../../common/sidebar';
// import TopBar from '../../common/topBar';
import axios from 'axios';
import { PnkConnect } from '../../pnk-react/pnk-miniredux';
import '../../assets/styling/home.css';
import Banner from './banner';
import Orders from './orders';
import EventsList from './events';
import ClassesList from './classes';
import GamesList from './games';
import AppUtils from '../../apputils';
import { UpcomingEvents } from '../../models/events';
//import { Notifications } from 'react-push-notification';
//import addNotification from 'react-push-notification';
import Notification from 'react-web-notification';
//import OneSignal from 'react-onesignal';
//import FriendlyCallsModal from './FriendlyCallsModal';
import Footer from '../../common/footer';
import { UpcomingTours } from '../../models/tour';
const img_path = 'https://www.kinshipliving.com/images/uploads/kinship/events/';

class homeContainer extends Component {
    constructor() {
        super()
        this.state = {
            getUpcomingEvents:true,
            getUpcomingTours:true,
            upcomingEventsList:[],
            upcomingToursList:[],
            title:'',
        }
    }

    HandleRouting = (route) => {
       
        AppUtils.HandlePageClick(this.props.componentprops, route)
    }

   

    HandleGetUpcomingEventsListSuccessResponse = (res)=>{
        if(res !== false){
        //    console.log(JSON.stringify(res))
            this.setState({
                getUpcomingEvents:false,
                upcomingEventsList:res.data.eventslist.rows

            })
        }
        else{
            this.setState({
                getUpcomingEvents:false
            })
        }
    }

    HandleGetUpcomingToursListSuccessResponse = (res)=>{
        if(res !== false){
        //    console.log(JSON.stringify(res))
            this.setState({
                getUpcomingTours:false,
                upcomingToursList:res.data.tourslist.rows

            })
        }
        else{
            this.setState({
                getUpcomingTours:false
            })
        }
    }

    
    showNotification = ()=>{

        let id = "61f221ca8248d1048785adbc";
       
var data = JSON.stringify({
  "app_id": "b73b1d9d-2e6e-43fe-81e1-b9ab31caba87",
//   "included_segments": [
//     "Subscribed Users"
//   ],
"channel_for_external_user_ids": "push",
 "include_external_user_ids":["61e6684a583fd4b8ad5dba9e", "	61f4f2029ba8916050acedeb", "61b03bdd2b732223ba2d4f66"],
 // "include_player_ids": ["1fd414d4-7d1c-11ec-aae9-4e5d719e838b", ],
  "data": {
    "foo": "bar"
  },
  "name":"Event",
  "contents": {
    "en": `Hello user please check out this new session Zumba organized by Armaan` 
  },
  
      "url":`https://www.kinshipliving.com/session-details/${id}`,
      "chrome_web_icon":`${img_path + '1643115904461wacking.jpg'}`
     
});

var config = {
  method: 'post',
  url: 'https://onesignal.com/api/v1/notifications',
  headers: { 
    'Authorization': 'Basic YWJmOTYyNDktODE0NC00Y2FjLWE2NTItODQxZmVhNThhNGNl', 
    'Content-Type': 'application/json'
  },
  data : data
};

axios(config)
.then(function (response) {
  console.log(JSON.stringify(response.data));
})
.catch(function (error) {
  console.log(error);
});

//         axios.post('https://onesignal.com/api/v1/notifications' , {
//             headers:{
                
//                 "Authorization": "Basic YWJmOTYyNDktODE0NC00Y2FjLWE2NTItODQxZmVhNThhNGNl",
//                 "Content-Type":"application/json; charset=utf-8"
//             },
            
            
//                 "app_id": "b73b1d9d-2e6e-43fe-81e1-b9ab31caba87",
//   "included_segments": ["Subscribed Users"],
//   "data": {"foo": "bar"},
//   "contents": {"en": "English Message"}
            
            
//         })


        // if(localStorage.getItem('current_user_id') !== '' && localStorage.getItem('current_user_id') !==null && localStorage.getItem('current_user_id') !== undefined){
        //     this.setState({
        //         ignore:false
        //     })
            this.Notification();
      //  }
        // else{
        //     this.setState({
        //         ignore:true
        //     })
        // }
    }

    Notification = ()=>{
  // alert('kkk')
        // addNotification({
        //     title: 'Warning',
        //     subtitle: 'This is a subtitle',
        //     message: 'This is a very long message',
        //     theme: 'darkblue',
        //     duration:8000,
        //     native: true, // when using native, your OS will handle theming.
        //     onclick:this.HandleOnClick.bind(this)
        // });
    
        // OneSignal.push(function() {
        //     OneSignal.setDefaultTitle("My Title");
        //   });

        // const now = Date.now();

        // const title = 'Kinship' + now;
        // const body = 'Hello' + new Date();
        // const tag = now;


        // const options = {
        //     tag: tag,
        //     body: body,
           
        //     lang: 'en',
        //   }

        //   this.setState({
        //     title: title,
        //     options: options
        //   });
    }

    HandleOnClick = ()=>{
        this.HandleRouting('upcoming-sessions')
    }
    componentDidMount = ()=>{

     //    var OneSignal = OneSignal || [];

        // OneSignal.push(["init", {
        //     appId: "b73b1d9d-2e6e-43fe-81e1-b9ab31caba87",
        //     subdomainName: "http://localhost:4444"
        //     // Your other init settings
        //   }]);

        // let externalUserId = "123456789"

        // OneSignal.push(function() {
        //     alert(externalUserId)
        //     OneSignal.setExternalUserId(externalUserId);
        //   });

    //  OneSignal.init({
    //         appId: "b73b1d9d-2e6e-43fe-81e1-b9ab31caba87"
    //       })


    //      await OneSignal.getUserIds(
    //         function (userDetails) { 
    //                         alert(userDetails.userId);
    //                         console.log(userDetails.userId);
    //                     }
    //      )
//    await OneSignal.startInit("b73b1d9d-2e6e-43fe-81e1-b9ab31caba87").getIds(
//         function (userDetails) { 
//             alert(userDetails.userId);
//             console.log(userDetails.userId);
//         }
//     ).endInit();
       
          
    }

    render() {
        return (
            <div>
                {/* <TopBar {...this.props} /> */}

                <Notification
                ignore={false}
              //  notSupported={this.handleNotSupported.bind(this)}
              //  onPermissionGranted={this.handlePermissionGranted.bind(this)}
              //    onPermissionDenied={this.handlePermissionDenied.bind(this)}
              //  onShow={this.handleNotificationOnShow.bind(this)}
               onClick={this.HandleOnClick.bind(this)}
              //  onClose={this.handleNotificationOnClose.bind(this)}
              //  onError={this.handleNotificationOnError.bind(this)}
                timeout={8000}
                title={this.state.title}
                options={this.state.options}
             //   swRegistration={this.props.swRegistration}
              />
             
                <Banner {...this.props} HandleRouting={this.HandleRouting} showNotification={this.showNotification} />
                <Orders {...this.props} HandleRouting={this.HandleRouting} />
                <EventsList {...this.props} upcomingEventsList={this.state.upcomingEventsList} />
                <ClassesList {...this.props} upcomingToursList={this.state.upcomingToursList} HandleRouting={this.HandleRouting} />
                <GamesList {...this.props} HandleRouting={this.HandleRouting} />
                <Footer {...this.props} HandleRouting={this.HandleRouting}/>
                {((this.state.getUpcomingEvents === true) ? UpcomingEvents(this.props.PnkStore, this.HandleGetUpcomingEventsListSuccessResponse) : "")}
                {((this.state.getUpcomingTours === true) ? UpcomingTours(this.props.PnkStore, this.HandleGetUpcomingToursListSuccessResponse) : "")}
               
            </div>
        )
    }
}


export const HomeContainer = PnkConnect(homeContainer, 'loginstatus', 'loginusername');